/**
 * Mutu Ancak API Service
 * Handles all API calls for quality inspection module
 */

import api from '../../../auth/apiClient';
import { MutuAncakData, MutuAncakFilters, MutuAncakSummaryResponse } from '../types';
import { MUTU_ANCAK_API_CONFIG, DEFAULT_CATEGORY_ID } from '../apiConfig';

export class MutuAncakApiService {
  /**
   * Fetch inspection summary data
   * @param filters - Filter parameters (estate_id, division_id, inspection_date)
   * @returns Promise with inspection data array
   */
  static async getSummary(filters: MutuAncakFilters): Promise<MutuAncakSummaryResponse> {
    try {
      const params: Record<string, any> = {
        estate_id: filters.estate_id,
        division_id: filters.division_id,
        inspection_date: filters.inspection_date,
        category_id: filters.category_id || DEFAULT_CATEGORY_ID,
      };

      const response = await api.get(MUTU_ANCAK_API_CONFIG.SUMMARY, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching mutu ancak summary:', error);
      throw error;
    }
  }
}

export default MutuAncakApiService;
